import React from 'react';

import { IconProps } from './types';

export const CheckmarkFilledIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M12 2.3999C6.69792 2.3999 2.4 6.69782 2.4 11.9999C2.4 17.302 6.69792 21.5999 12 21.5999C17.3021 21.5999 21.6 17.302 21.6 11.9999C21.6 6.69782 17.3021 2.3999 12 2.3999ZM17.3656 10.1655L11.3177 16.2134C11.1677 16.3634 10.9635 16.4478 10.7521 16.4478C10.5396 16.4478 10.3365 16.3634 10.1865 16.2134L7.42396 13.4509C7.11146 13.1384 7.11146 12.6322 7.42396 12.3197C7.73646 12.0072 8.24271 12.0072 8.55521 12.3197L10.7521 14.5166L16.2344 9.03428C16.5469 8.72178 17.0531 8.72178 17.3656 9.03428C17.6781 9.34678 17.6781 9.85303 17.3656 10.1655Z"
          fill={color}
        />
      </svg>
    );
  },
);
